"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisuallyHidden = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireDefault(require("react"));

var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "jsx-3199371217"
  }, children, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "3199371217"
  }, ["span.jsx-3199371217{-webkit-clip:rect(1px 1px 1px 1px);clip:rect(1px 1px 1px 1px);-webkit-clip:rect(1px,1px,1px,1px);clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;}"]));
};

exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJWaXN1YWxseUhpZGRlbiIsImNoaWxkcmVuIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVmlzdWFsbHlIaWRkZW4vVmlzdWFsbHlIaWRkZW4udHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBjb25zdCBWaXN1YWxseUhpZGRlbjogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48dW5rbm93bj4+ID0gKHtcbiAgY2hpbGRyZW4sXG59KSA9PiAoXG4gIDxzcGFuPlxuICAgIHtjaGlsZHJlbn1cbiAgICA8c3R5bGUganN4PntgXG4gICAgICBzcGFuIHtcbiAgICAgICAgY2xpcDogcmVjdCgxcHggMXB4IDFweCAxcHgpO1xuICAgICAgICBjbGlwOiByZWN0KDFweCwgMXB4LCAxcHgsIDFweCk7XG4gICAgICAgIGhlaWdodDogMXB4O1xuICAgICAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgICAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgICAgIHdpZHRoOiAxcHg7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L3NwYW4+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVPLElBQU1BLGNBQTBELEdBQUcsU0FBN0RBLGNBQTZEO0VBQUEsSUFDeEVDLFFBRHdFLFFBQ3hFQSxRQUR3RTtFQUFBLG9CQUd4RTtJQUFBO0VBQUEsR0FDR0EsUUFESDtJQUFBO0VBQUEsb09BSHdFO0FBQUEsQ0FBbkUifQ==